module.exports = __webpack_public_path__ + "img/pdf.eaca0cda.png";